"use client";

import { useEffect } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import Autoplay from "embla-carousel-autoplay";
import { Quote } from "lucide-react";
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const testimonials = [{
    id: 1,
    quote: "K&M Mechanical Services provided exceptional service and my new HVAC system works flawlessly.",
    author: "Jane D.",
    location: "Pittsburgh, PA"
  }, {
    id: 2,
    quote: "Reliable and professional team that keeps our commercial HVAC running smoothly.",
    author: "Business Owner",
    location: "Pittsburgh, PA"
  }, {
    id: 3,
    quote: "Their technicians are knowledgeable and always arrive on time. Highly recommend!",
    author: "Michael R.",
    location: "Pittsburgh, PA"
  }, {
    id: 4,
    quote: "Energy bills went down significantly after their system optimization. Great work!",
    author: "Sarah L.",
    location: "Pittsburgh, PA"
  }];
  const autoplay = Autoplay({
    delay: 4000,
    stopOnInteraction: true,
    stopOnMouseEnter: true
  });
  return <section ref={ref} className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
              Client Testimonials
            </h2>
            <p className="text-muted-foreground text-lg">
              What our customers say about our HVAC services
            </p>
          </div>

          <Carousel opts={{
          align: "center",
          loop: true,
          axis: "y"
        }} plugins={[autoplay]} orientation="vertical" className="w-full">
            <CarouselContent className="h-[320px] md:h-[280px]">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pt-4">
                  <Card className="border border-border shadow-soft">
                    <CardContent className="flex flex-col items-center text-center p-8 md:p-10">
                      <Quote className="w-10 h-10 text-primary mb-6" />
                      <blockquote className="text-foreground text-lg md:text-xl mb-6 font-sans leading-relaxed">
                        "{testimonial.quote}"
                      </blockquote>
                      <footer className="mt-auto">
                        <cite className="not-italic">
                          <div className="font-display font-semibold text-foreground text-base">
                            {testimonial.author}
                          </div>
                          <div className="text-muted-foreground text-sm mt-1">
                            {testimonial.location}
                          </div>
                        </cite>
                      </footer>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hover:bg-primary hover:text-foreground-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
            <CarouselNext className="hover:bg-primary hover:text-foreground-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
          </Carousel>
        </div>
      </div>
    </section>;
}